import { useNavigate } from "react-router-dom";
import { ScoreRing, CLASS_STYLES } from "@/lib/match";

export const BUCKETS = [
  { key: "high", label: "High Matches", sub: "90–100", color: "hsl(var(--gold))" },
  { key: "strong", label: "Strong Matches", sub: "80–89", color: "hsl(var(--teal))" },
  { key: "possible", label: "Possible Matches", sub: "70–79", color: "hsl(200 60% 45%)" },
  { key: "transferable", label: "Potential Transferable Candidates", sub: "cross-profession fit", color: "hsl(262 52% 55%)" },
  { key: "not_qualified", label: "Not Qualified", sub: "below threshold", color: "hsl(215 16% 55%)" },
];

export default function MatchBuckets({ matchData }) {
  const navigate = useNavigate();
  if (!matchData) return null;
  return (
    <div className="space-y-7">
      {BUCKETS.map(({ key, label, sub, color }) => {
        const items = matchData.buckets[key] || [];
        return (
          <div key={key} data-testid={`bucket-${key}`}>
            <div className="flex items-center gap-2 mb-3">
              <span className="h-2.5 w-2.5 rounded-full" style={{ background: color }} />
              <h3 className="font-head font-semibold text-base">{label}</h3>
              <span className="text-xs text-muted-foreground">· {sub}</span>
              <span className="ml-1 inline-flex items-center justify-center min-w-[22px] h-[22px] px-1.5 rounded-full bg-secondary text-foreground/70 text-xs font-semibold tabular-nums">{items.length}</span>
            </div>
            {items.length === 0 ? (
              <p className="text-sm text-muted-foreground pl-[18px]">No candidates in this tier.</p>
            ) : (
              <div className="grid md:grid-cols-2 gap-3">
                {items.map((m) => {
                  const pill = CLASS_STYLES[m.classification] || "bg-slate-100 text-slate-600 border-slate-200";
                  return (
                    <div key={m.candidate_id} data-testid={`match-cand-${m.candidate_id}`} onClick={() => navigate(`/candidates/${m.candidate_id}`)}
                      className="card-hover flex items-center gap-3.5 bg-card border border-border rounded-lg shadow-card p-3.5 cursor-pointer">
                      <ScoreRing score={m.score || 0} size={44} />
                      <div className="min-w-0 flex-1">
                        <div className="font-medium text-foreground truncate">{m.candidate_name || "Unnamed"}</div>
                        <div className="text-xs text-muted-foreground truncate">{m.candidate_title || m.candidate_classification}</div>
                        {m.classification && <span className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[10px] font-medium capitalize mt-1.5 ${pill}`}>{m.classification}</span>}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
